<script lang="ts">
    import SelectLocation from '../Location/SelectLocation.svelte';
    import { Location } from '../Location/Location';
    import { onMount } from 'svelte';
    import { mainMenu } from '../../../stores/store';
    import StyleLikeFilterItem from '../../shared/StyleLikeFilterItem.svelte';

    onMount(() => {
        $mainMenu.currentPage = 'PageWorkshop';
    });
</script>

<div
    style="display: flex; column-gap: 20px; row-gap: 20px; padding: 40px; flex-wrap: wrap; background-color: #fefefe; overflow: auto; height: 100%;"
>
    <div style="display: flex; flex-direction: column; row-gap: 3px;">
        <StyleLikeFilterItem mode="vehicle">
            <SelectLocation location={new Location()} title="Wybierz punkt początkowy" />
        </StyleLikeFilterItem>
        <StyleLikeFilterItem mode="vehicle">
            <SelectLocation location={new Location()} title="Wybierz punkt końcowy" />
        </StyleLikeFilterItem>
    </div>
</div>
